// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"F6-z"};